
import { Component, Prop, Vue } from "vue-property-decorator";

interface TypeTag {
  id: string;
  libelle: string;
}

@Component({
  components: {},
})
/** Small color-coded label, typically for an activity type or status. Color is driven by `type`'s id via CSS classes (`tag--1`, `tag--2`, ...). */
export default class Tag extends Vue {
  /** Either the full type object (shows `type.libelle`) or just its id/status string (renders as a dot when `small`). */
  @Prop({ required: true }) type!: TypeTag | string | null;
  /** Renders as a small colored dot with no label instead of the full pill. */
  @Prop({ required: false, default: false }) small?: boolean;
}
